import { Navigate, useLocation, useRoutes } from "react-router-dom";
import { APP_ROUTES } from "./routes";
import { useAuth } from "../contexts/auth";
import { useToasts } from "../contexts/toasts";
import { useEffect } from "react";
import { Users } from "../api/Users";
import { UnsavedChangesProvider } from "../contexts/unsavedChanges";

export default function AppRouter() {
  const { pathname } = useLocation();
  const { token, loggedUser, setLoggedUser, handleLogout } = useAuth();
  const { showToast } = useToasts();
  const routes = useRoutes(APP_ROUTES);

  useEffect(() => {
    if (token && !loggedUser) {
      Users.getUserInfo().then(
        ({ data }) => {
          setLoggedUser(data.user);
        },
        () => {
          showToast(
            "user-error",
            "Errore nella validazione dell'utente",
            "",
            "danger"
          );
          handleLogout();
        }
      );
    }
  }, [token, loggedUser, setLoggedUser, showToast, handleLogout]);

  if (pathname !== "/login" && !token) {
    // Public, token-driven pages reachable while logged out. The account
    // activation and password-reset links land here from an email, so they
    // must bypass the login redirect — otherwise the recipient is bounced to
    // /login instead of the choose-password page. `/verify/...` covers both
    // `/verify/:token` and `/verify/re-issue-password/:token`.
    const isPublicPath =
      pathname.startsWith("/verify/") ||
      [
        "/domande-frequenti",
        "/contattaci",
        "/conferma-registrazione",
        "/privacy-policy",
      ].includes(pathname);
    if (!isPublicPath) {
      return <Navigate to="/login" />;
    }
  } else if (pathname === "/login" && token) {
    return <Navigate to="/" />;
  }

  return <UnsavedChangesProvider>{routes}</UnsavedChangesProvider>;
}
